<template>
  <!-- 我的招标：2 个 tab（我的招标 = 我负责的客户 / 我下属的 = 我下属负责的客户） -->
  <BidProjectList :show-creator-filter="true" :show-tabs="true" />
</template>

<script lang="ts" setup>
import BidProjectList from '../components/BidProjectList.vue'

defineOptions({ name: 'CrmBidMy' })
</script>
